module.exports = __webpack_public_path__ + "img/timeend.0d465a15.png";